<template>
    <form-row title="Closing Agent">
        <contact-selector
            name_prefix="closing_agent"
            :available_contacts="available_contacts"
            contact_type="closing_agent"
            :value="{
                contact_id: closing.contact_id,
                name: closing.closing_agent_name,
                email: closing.closing_agent_email,
                phone: closing.closing_agent_contract_number,
            }"
            name_label="Agent Name"
            phone_label="Contact #"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
import ContactSelector from '../../components/contact-selector.vue';

export default {
    components: {
        ContactSelector,
    },

    props: {
        closing: {},
        available_contacts: { default: () => [] },
        read_only: { default: false },
    },
}
</script>
